import {BackBtn, BackBtnWhite} from '../../theme/icons';
import {StyleSheet, TouchableOpacity, View, Text, Image, Pressable, Platform} from 'react-native';
import React, { useState } from 'react';
import images from '../../theme/images';
import GoBack_btn_copy from './goBack';


function HeaderLeft({navigation, type, isAfterInitial, screenName, config, headerStyle, hideThis, siteURL}) {
    const [imgWidth, setImageWidth] = useState(0);
    const [imgHeight, setImageHeight] = useState(0);

    const outputType = () => {
        let buttons = <></>;
        if(config.leftButtons){
           buttons = config.leftButtons.map(function(item, i){
                var url = item.url;
                var siteURL = config.siteURL;
            
                if(url.startsWith("/")){
                    url = siteURL + url;
                }
            
                if (url.includes("?") || url.includes("stripe")){
                console.log("do nothing");
                } else {
                    if (url.substr(-1) != '/') {url += '/'}
                }
                return (
                    <Pressable
                        key={i}
                        style={{marginLeft: 8}} 
                        onPress={() => navigation.push("MenuItem" , {
                            url: item.url, 
                            isAfterInitial: true,
                            hideThis: hideThis
                        })} 
                    >
                        <Image source={{uri: item.icon}} 
                            style={{
                                width: 28, 
                                height: 28, 
                                resizeMode: "contain", 
                                tintColor: headerStyle.styles.topBarIconColor
                            }} 
                            tintColor={ headerStyle.styles.topBarIconColor } 
                        />
                    </Pressable>
               )
            })
        }

        if((type == "logoOnly" && config.alignment == "left") || (type == "logoLeftBurgerRight") || (type == "logoLeftNavRight")){
            let size = Image.getSize(config.logo, (width, height) => {setImageWidth(width); setImageHeight(height);}, (error) => console.log(error));
            if(imgWidth !== 0 && imgHeight !== 0){
                let ratio = 22 / imgHeight;
                console.log("width: ", imgWidth);
                size = (imgWidth * ratio);
                return (
                    config.useLogo ? (
                        <Image 
                            source={config.localImage ? config.localImage : {uri: config.logo}} 
                            style={{ width: size, height: 30, resizeMode: "contain"}} 
                        />
                    ) : (
                        <Text numberOfLines={1} style={[styles.headerTitle, { color: headerStyle.styles.topBarTextColor }]}>{config.label}</Text>
                    )
                )
            } else {
                return (
                    <Text numberOfLines={1} style={[styles.headerTitle, { color: headerStyle.styles.topBarTextColor }]}>{config.label}</Text>
                ) 
            }
        } else if(type == "logoMidNavBoth"){
            return (
                buttons
            )
        } else {
            return (
                <></>
            )
        }
    }

    const onPress = () => {
        if(type == 2 || type == 3){
            navigation.navigate("TabNav")

        } else if(type == 4){
            if (config.url.includes("?") || config.url.includes("stripe")){
                console.log("do nothing");
            } else {
                if (config.url.substr(-1) != '/') config.url += '/';
            }
            navigation.push(screenName , { screenName:"MenuItem", url: config.url, isAfterInitial: true, hideThis: hideThis});
        } else {
            null
        }
    }

    if(!isAfterInitial){
        return(
            <TouchableOpacity
                onPress={onPress}
                style={Platform.OS == "web" ? styles.leftSection : null}
            >
                {outputType()}
            </TouchableOpacity>
        )
    } else {
        return (
            <GoBack_btn_copy 
                navigation={navigation} 
                color={headerStyle.styles.topBarIconColor} 
                paddingLeft={true} 
            />
        )
    }
}
export default HeaderLeft;

const styles = StyleSheet.create({
    leftSection:{
        paddingHorizontal: 15
    },
    headerTitle: {
        fontSize: 20, 
        fontWeight: "700", 
        maxWidth: 200
    }
});